<div class="string">
  <div class="nut">
    <div class="note">{{ open }}</div>
  </div>
  <div
    [ngClass]="{
      dotted: isDotted(fret.fretNumber)
    }"
    *ngFor="let fret of frets"
    class="fret"
  >
    <div *ngIf="fret.highlighted" class="note">
      <!-- {{ fret.highlighted ? fret.displayName : "" }} -->
      {{ fret.displayName }}
    </div>
  </div>
</div>
